import React, { useState, useEffect, useContext } from "react";
import "./App.css";
import { FormContainer } from "./components/FormContainer";
import { Menu } from "./components/Menu";
import { MobileMenu } from "./components/MobileMenu"; // Importa el nuevo componente
import { QuoteContextProvider, quoteContext } from "./context/quotesContext";
import { StaticRouter } from "react-router-dom/server";
import { Routes, Route, BrowserRouter, RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./components/Login";
import { ShipmentStatus } from "./components/ShipmentStatus";

function App() {

  const [isLoginOpen, setIsLoginOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWide < 520);

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    const storedProvider = localStorage.getItem("provider");

    if (storedToken && storedProvider) {
      setIsLoginOpen(false);
    } else {
      setIsLoginOpen(true);
    }

    const handleResize = () => {
      setIsMobile(window.innerWide < 520);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  return (
    <QuoteContextProvider>
   
        <div className={`App ${isLoginOpen ? "inactive" : ""}`}>
          <MobileMenu /> 
          <Menu />
          {isLoginOpen && <Login onClose={() => setIsLoginOpen(false)} />}
            
           
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<FormContainer />} />
              <Route path="/payment/status/success" element={<ShipmentStatus />} />
            </Routes>
        </BrowserRouter>
           
        </div>

    </QuoteContextProvider>
  );
}

export default App;
